import { Injectable } from '@angular/core';
import { CanMatch, Route, UrlSegment } from '@angular/router';
import { CommonService } from '../common.service';

@Injectable({ providedIn: 'root' })
export class EnterpriseReferralGuard implements CanMatch {
    constructor(private readonly _commonService: CommonService) {}

    canMatch(_route: Route, _segments: UrlSegment[]): boolean {
        const flag = this._commonService.appProfileDataAsValue?.currentOrganization?.enterprise_referral_enabled;
        // If profile data isn't loaded yet (e.g. hard refresh before MainResolver runs),
        // default to true so enterprise orgs are not incorrectly routed to the legacy module.
        if (flag === undefined || flag === null) {
            return true;
        }
        return flag;
    }
}
